import { render, staticRenderFns } from "./ConfiguracoesExclusivas.vue?vue&type=template&id=47027768"
import script from "./ConfiguracoesExclusivas.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesExclusivas.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesExclusivas.vue?vue&type=style&index=0&id=47027768&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports